import { nameOf } from '../shared/common';
import { QueryParser } from '../shared/QueryParser';
import ModularConfiguratorPageQuery from './ModularConfiguratorPageQuery';

class ModularConfiguratorPageQueryParser extends QueryParser {
  public static toModel(query: Map<string, string>): ModularConfiguratorPageQuery {
    for (const [key, value] of query) {
      query.set(key, decodeURIComponent(value));
    }

    const layoutCode = QueryParser.getValue(query, nameOf<ModularConfiguratorPageQuery>('layoutCode'), '');
    const code = QueryParser.getValue(query, nameOf<ModularConfiguratorPageQuery>('code'), '');
    const debugPerformance =
      QueryParser.getValue(query, nameOf<ModularConfiguratorPageQuery>('debugPerformance'), '').toLowerCase() ===
      'true';
    const debugMaterial = QueryParser.getValue(query, nameOf<ModularConfiguratorPageQuery>('debugMaterial'), '');

    return new ModularConfiguratorPageQuery(layoutCode, code, debugPerformance, debugMaterial);
  }

  public static toQuery(queryModel: ModularConfiguratorPageQuery): Map<string, string> {
    const query = new Map<string, string>();

    Object.entries(queryModel).forEach(([name, value]) => {
      if (!!value) {
        QueryParser.setValue(query, name, encodeURIComponent(value));
      }
    });

    return query;
  }
}

export default ModularConfiguratorPageQueryParser;
